export enum EInitEventTypeCode {
  NNR = 'NNR', // Нарушение нормальной работы
  SB = 'SB', // Событие безопасности
  PPR = 'PPR',
  MM = 'MM',
}
